import { render, staticRenderFns } from "./CreateOptoutsModal.vue?vue&type=template&id=ecd8d1ce&scoped=true"
import script from "./CreateOptoutsModal.vue?vue&type=script&lang=js"
export * from "./CreateOptoutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd8d1ce",
  null
  
)

export default component.exports